import { Flame, Lock } from "lucide-react";
import { MILESTONE_LABELS } from "./MilestoneBadge";

const SHELF = [7, 30, 100];

export const BadgeShelf = ({ streakInfo, onViewBadge, palette }) => {
  const earned = streakInfo?.milestones || [];
  const current = streakInfo?.streak || 0;
  return (
    <div className="rounded-2xl border bg-white p-5" style={{ borderColor: palette.border }} data-testid="badge-shelf">
      <h2 className="text-lg font-bold font-body mb-1" style={{ color: palette.primary }}>Milestone Badges</h2>
      <p className="text-xs opacity-70 mb-4">Earned by keeping your daily rhythm alive</p>
      <div className="grid grid-cols-3 gap-3">
        {SHELF.map((days) => {
          const has = earned.includes(days);
          const remaining = Math.max(0, days - current);
          return (
            <button
              key={days}
              onClick={() => has && onViewBadge(days)}
              disabled={!has}
              className="rounded-2xl p-3 text-center border transition-transform active:scale-95"
              style={{
                borderColor: has ? "#D97706" : palette.border,
                backgroundColor: has ? "#D9770614" : "#FAFBFA",
                opacity: has ? 1 : 0.7,
              }}
              data-testid={`badge-${days}`}
            >
              <div
                className="w-11 h-11 rounded-full mx-auto mb-2 flex items-center justify-center border-2"
                style={{
                  borderColor: has ? "#D97706" : "#C4CEC8",
                  backgroundColor: has ? "#D97706" : "#EDF1EE",
                }}
              >
                {has ? (
                  <Flame className="w-5 h-5" style={{ color: "#FCD34D" }} />
                ) : (
                  <Lock className="w-4 h-4" style={{ color: "#9AA69E" }} />
                )}
              </div>
              <p className="text-sm font-bold" style={{ color: has ? "#B45309" : "#6B776F" }}>{days} days</p>
              <p className="text-[10px] mt-0.5 leading-tight" style={{ color: has ? "#B45309" : "#9AA69E" }}>
                {has ? MILESTONE_LABELS[days] : `${remaining} to go`}
              </p>
            </button>
          );
        })}
      </div>
      <p className="text-[11px] mt-3 flex items-center gap-1" style={{ color: streakInfo?.grace_used_this_month ? "#B45309" : "#8A968F" }} data-testid="grace-day-note">
        🍃 {streakInfo?.grace_used_this_month
          ? `Grace day used this month (${streakInfo.grace_used_this_month}) — your streak was saved`
          : "One grace day a month protects your streak if you miss a single day"}
      </p>
    </div>
  );
};
